import React, { useState } from 'react';
import Image from 'next/image';
import Link from '../Link';
import ControlesCarrito from '../ControlesCarrito';
import { currency, getFotoProductoUrl } from '../../utils/utils';
import { precioConDescuentoMayorista } from '../../utils/mayorista';
import { sendSCEvent } from '../../utils/SCEvent';
import itemStyles from './styles.module.scss';

type ItemProductoMayoristaProps = {
    data: any
    isCarousel?: boolean
}

const ItemProductoMayorista = (props: ItemProductoMayoristaProps) => {

  const producto = props.data;
  const isCarousel = props.isCarousel;
  const [hovered, setHovered] = useState(false);

  const mainImage = getFotoProductoUrl(producto.attributes?.fotos?.data[0]) || "https://dummyimage.com/340x340/000000/ffffff";
  const hoverImage = getFotoProductoUrl(producto.attributes?.fotos?.data[1]) || mainImage;

  const precioMayorista = precioConDescuentoMayorista(producto.attributes?.precioFinal);

  // GUARDA EVENTO SC
  async function sendEventToSC() {
    sendSCEvent({
      type: 'click',
      element: 'Botón "Ver detalles"',
      slot: 0,
      detail: `${producto?.attributes?.nombre} || Producto #${producto?.id}`,
      owner: null,
      filter1: producto?.attributes?.tematica?.data?.attributes?.nombre,
      filter2: producto?.attributes?.tipo?.data?.attributes?.nombre,
      filter3: producto?.attributes?.color?.data?.attributes?.nombre,
    });
  }

  return (<>
    <div className={`${itemStyles.item} ${isCarousel ? itemStyles.itemCarousel : ''}`}>
      {producto.attributes?.novedad && <div className={itemStyles.cucarda}>¡Novedad!</div>}
      <Link href={`/productos/${producto.attributes?.slug}?mayorista=true`} target="_blank">
        <div className={itemStyles.up}>
          <Image
            className={itemStyles.imagenProducto}
            src={hovered ? hoverImage : mainImage}
            alt={producto.attributes?.nombre || "Producto We Celebrate!"}
            width={272}
            height={342}
            onClick={() => sendEventToSC()}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          />
        </div>
      </Link>
      <div className={itemStyles.down}>
        <Link href={`/productos/${producto.attributes?.slug}?mayorista=true`} target="_blank">
          <h3 className={itemStyles.nombre} title={producto.attributes?.nombre}>{producto.attributes?.nombre || '-'}</h3>
        </Link>

        <div className={itemStyles.contenedorPrecios}>
          <span className={itemStyles.precioTachado}>$ {currency(producto.attributes?.precioFinal)}</span>
          <span className={itemStyles.precio}>$ {currency(precioMayorista)} <small>mayorista</small></span>
        </div>

        <ControlesCarrito producto={producto} leftAlign={true} mayorista={true} />
      </div>
    </div>
  </>);
};

export default ItemProductoMayorista;
